import { Navigate, Outlet } from "react-router";

import { defaultAuthenticatedPath } from "@/features/auth/lib/auth-store";
import { useAuth } from "@/features/auth/lib/use-auth";

/** Admin-only portal screens. Backend matches with `@Roles(ADMIN)`. */
export function AdminRoute() {
	const { isPortalAdmin } = useAuth();

	if (!isPortalAdmin) {
		return <Navigate to={defaultAuthenticatedPath()} replace />;
	}

	return <Outlet />;
}

/** Request queue (`@Roles(ADMIN, STAFF)` + `@RequireTags(DISCOUNT_REQUESTS)`). */
export function RequestsRoute() {
	const { canWorkRequests } = useAuth();

	if (!canWorkRequests) {
		return <Navigate to="/account" replace />;
	}

	return <Outlet />;
}
